export const CUSTOM_VALUE_LABEL = 'left';
export const ZERO_PERCENT_PEAK_LABEL = 'center';
export const NATURAL_DELIVERY_LABEL = 'right';
